module.exports = __webpack_public_path__ + "img/covid.03d5a7ac.jpg";